import type { LinkedDocumentationTarget } from 'shared/domain/issue/linkedDocumentation/types';
import type { ExportDocumentOutDto } from 'shared/domain/issue/mapping/exportDocument/toOut/createExportDocumentOutDto';

/** A setting of an exported version saved after the export itself, so it may fail on its own (PT-7318). */
export enum ExportedVersionSetting {
  name = 'name',
  current = 'current',
}

export type ExportToDocumentationResultData = {
  documentationId: string;
  documentationName?: string;
  versionId: string;
  /** Settings the user chose that could not be saved; the export itself succeeded. */
  unsavedVersionSettings?: ExportedVersionSetting[];
};

/** What the issue was linked to. */
export type ImportFromDocumentationResultData = LinkedDocumentationTarget;

export type RemoveLinkedDocumentationResultData = {
  linkedDocumentationId: string;
};

/** The backend's import body (PT-7117): `{ documentationId, type, versionId? }`. */
export type ImportFromDocumentationPayload = LinkedDocumentationTarget;

/** What the user decided about the exported version (PT-7318); the defaults are what a new documentation gets. */
export interface ExportedVersionOptions {
  /** Set only when it differs from the name the backend gives (the file's name without its extension). */
  name?: string;
  /** Whether the version becomes the documentation's current one; `true` when left out. */
  makeCurrent?: boolean;
}

/** Exports a document of the issue to the documentation and links it to the issue. */
export interface ExportToDocumentationRequest {
  issueId: string;
  documentId: string;
  payload: ExportDocumentOutDto;
  version?: ExportedVersionOptions;
  /** The document as stored on this device, removed once exported. */
  localId?: number;
  imageRotation?: number;
}

/** Links a documentation, or one of its versions, to the issue. */
export interface ImportFromDocumentationRequest {
  issueId: string;
  payload: ImportFromDocumentationPayload;
}

export interface RemoveLinkedDocumentationRequest {
  issueId: string;
  linkedDocumentationId: string;
}
